/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { opensignup } from '../models/opensignup';
import type { parametersFilter } from '../models/parametersFilter';
import type { parametersFilterCount } from '../models/parametersFilterCount';
import type { responsesPartMeta } from '../models/responsesPartMeta';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OpensignupsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * count opensignups
   * Count opensignups (with filtering, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * @param filter
   * @returns any Count of opensignup documents found. Wrapped in a JsonAPI root response with wrapped count result as data.
   * @throws ApiError
   */
  public getApiServicesecurityOpensignupsCount(
    filter?: parametersFilterCount,
  ): CancelablePromise<{
    data?: {
      count?: number;
    };
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/opensignups/count',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find one opensignup
   * Find one opensignup by its unique identifier.
   * @param identifier opensignup unique identifier
   * @returns any One opensignup document found. Wrapped in a JsonAPI root response with document as data.
   * @throws ApiError
   */
  public getApiServicesecurityOpensignups(
    identifier: string,
  ): CancelablePromise<{
    data?: opensignup;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/opensignups/{identifier}',
      path: {
        'identifier': identifier,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update one existing opensignup
   * Partially update one existing opensignup
   * @param identifier opensignup unique identifier
   * @param requestBody
   * @returns any updated opensignup. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityOpensignups(
    identifier: string,
    requestBody?: opensignup,
  ): CancelablePromise<{
    data?: opensignup;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/opensignups/{identifier}',
      path: {
        'identifier': identifier,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * find many opensignups
   * Find many opensignups (with filtering, projection, pagination and limiting). You can use filters in the query parameters (properly URL encoded) to restrict the search results:
   * - To restrict the search to specific values for a given field name, you can use the following syntax: filter[where][fieldName][eq]=value. Note that you can also nest the filter object to filter on multiple fields, like so: filter[where][and][0][fieldName1][eq]=value1&filter[where][and][1][fieldName2][eq]=value2. You can also use operators like gt, gte, lt, lte, ne, in, nin, etc.
   * - To limit the number of results returned by the query, use the following syntax: filter[limit]=25&filter[skip]=25
   * - To only return specific fields, use the projection query parameter. Usage is as follows: filter[fields][fieldName1]=true&filter[fields][fieldName2]=true.
   * @param filter
   * @returns any One or many opensignup documents found. Wrapped in a JsonAPI root response with collection of documents as data.
   * @throws ApiError
   */
  public getApiServicesecurityOpensignups1(
    filter?: parametersFilter,
  ): CancelablePromise<{
    data?: Array<opensignup>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/servicesecurity/opensignups',
      query: {
        'filter': filter,
      },
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * create one or multiple opensignups
   * Create one or multiple opensignups
   * @param requestBody
   * @returns any One or many opensignup documents created. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public postApiServicesecurityOpensignups(
    requestBody?: (opensignup | Array<opensignup>),
  ): CancelablePromise<{
    data?: (opensignup | Array<opensignup>);
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/servicesecurity/opensignups',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

  /**
   * partially update many existing opensignup
   * Partially update many existing opensignup
   * @param requestBody
   * @returns any opensignups updated. Wrapped in a JsonAPI root response.
   * @throws ApiError
   */
  public patchApiServicesecurityOpensignups1(
    requestBody?: Array<opensignup>,
  ): CancelablePromise<{
    data?: Array<opensignup>;
    meta?: responsesPartMeta;
  }> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/servicesecurity/opensignups',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        500: `default error response`,
      },
    });
  }

}
